var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStripe144X96(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "144px",
    height: "96px",
    viewBox: "0 0 144 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.382812 48.769531 C 127.382812 40.890625 123.570312 34.675781 116.277344 34.675781 C 108.953125 34.675781 104.523438 40.890625 104.523438 48.707031 C 104.523438 57.96875 109.753906 62.644531 117.261719 62.644531 C 120.921875 62.644531 123.691406 61.816406 125.785156 60.644531 L 125.785156 54.492188 C 123.691406 55.539062 121.292969 56.183594 118.246094 56.183594 C 115.261719 56.183594 112.617188 55.136719 112.277344 51.507812 L 127.324219 51.507812 C 127.324219 51.109375 127.382812 49.507812 127.382812 48.769531 Z M 112.183594 45.847656 C 112.183594 42.371094 114.308594 40.921875 116.246094 40.921875 C 118.125 40.921875 120.125 42.371094 120.125 45.847656 Z M 112.183594 45.847656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 92.644531 34.675781 C 89.628906 34.675781 87.691406 36.09375 86.617188 37.078125 L 86.214844 35.167969 L 79.445312 35.167969 L 79.445312 71.046875 L 87.136719 69.414062 L 87.167969 60.707031 C 88.277344 61.507812 89.90625 62.644531 92.617188 62.644531 C 98.125 62.644531 103.136719 58.214844 103.136719 48.460938 C 103.109375 39.539062 98.03125 34.675781 92.644531 34.675781 Z M 90.800781 55.875 C 88.984375 55.875 87.90625 55.230469 87.167969 54.429688 L 87.136719 43.015625 C 87.9375 42.125 89.046875 41.507812 90.800781 41.507812 C 93.601562 41.507812 95.539062 44.644531 95.539062 48.675781 C 95.539062 52.800781 93.628906 55.875 90.800781 55.875 Z M 90.800781 55.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 76.585938 24.953125 L 68.863281 26.585938 L 68.863281 32.863281 L 76.585938 31.199219 Z M 76.585938 24.953125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 68.863281 35.199219 L 76.585938 35.199219 L 76.585938 62.125 L 68.863281 62.125 Z M 68.863281 35.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 60.585938 37.476562 L 60.09375 35.199219 L 53.445312 35.199219 L 53.445312 62.125 L 61.136719 62.125 L 61.136719 43.875 C 62.953125 41.507812 66.03125 41.9375 66.984375 42.277344 L 66.984375 35.199219 C 66 34.832031 62.398438 34.152344 60.585938 37.476562 Z M 60.585938 37.476562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 45.199219 28.523438 L 37.691406 30.125 L 37.660156 54.769531 C 37.660156 59.324219 41.078125 62.675781 45.628906 62.675781 C 48.152344 62.675781 50 62.214844 51.015625 61.660156 L 51.015625 55.414062 C 50.03125 55.816406 45.167969 57.230469 45.167969 52.675781 L 45.167969 41.753906 L 51.015625 41.753906 L 51.015625 35.199219 L 45.167969 35.199219 Z M 45.199219 28.523438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 24.398438 43.015625 C 24.398438 41.816406 25.382812 41.355469 27.015625 41.355469 C 29.355469 41.355469 32.308594 42.0625 34.644531 43.324219 L 34.644531 36.09375 C 32.09375 35.078125 29.570312 34.675781 27.015625 34.675781 C 20.769531 34.675781 16.617188 37.9375 16.617188 43.382812 C 16.617188 51.875 28.308594 50.523438 28.308594 54.183594 C 28.308594 55.601562 27.078125 56.0625 25.355469 56.0625 C 22.800781 56.0625 19.539062 55.015625 16.953125 53.601562 L 16.953125 60.921875 C 19.816406 62.152344 22.707031 62.675781 25.355469 62.675781 C 31.753906 62.675781 36.152344 59.507812 36.152344 54 C 36.125 44.832031 24.398438 46.460938 24.398438 43.015625 Z M 24.398438 43.015625 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe144X96);
export default __webpack_public_path__ + "static/media/stripe_144x96.4512f807eafb2878375b1fbe90688f84.svg";
export { ForwardRef as ReactComponent };